module.exports = __webpack_public_path__ + "img/vegan.55dc7481.svg";